export const NOT_ASSIGNED_LABEL = "Not assigned";
export const NOT_ASSIGNED_RAW_ID = "not_assigned";
export const STANDALONE_LABEL = "Standalone";

export const ENTITY_HEADING = "ENTITY MAPPING";
export const ENTITY_TOOLTIP =
  "Select one or more entities from the table to enable and apply these actions";
export const BILLING_GROUP_HEADING = "BILLING GROUP MAPPING";
export const BILLING_GROUP_TOOLTIP =
  "Select one or more billing groups from the table to enable and apply these actions";
export const EDIT_ENTITY_DETAILS_HEADING = "EDIT ENTITY DETAILS";
export const EDIT_ENTITY_DETAILS_TOOLTIP =
  "Select one or more entities from the table to enable and apply these actions";
export const OVERRIDE_EUM_VALUE_LABEL = "Override current EUM value";
export const EDIT_EUM_CALCULATION_VALUES_LABEL = "Edit EUM calculation values";
export const EUM_MULTI_SELECT_DISABLED_TOOLTIP =
  "This action can only be applied to one entity at a time.";
export const ROLE_DISABLED_TOOLTIP =
  "You don't have the permissions required to trigger this bulk action.";
export const MISSING_GROUP_TOOLTIP = "This billing group does not exist in the system.";
export const MIXED_CHANGE_TYPES_ERROR =
  "EUM changes can't be combined with other changes in the same case. Submit or discard the existing changes first.";

export const REASON_CODE_OPTIONS = [
  { value: "client_dispute", label: "Client Dispute" },
  { value: "data_correction", label: "Data Correction" },
  { value: "contract_amendment", label: "Contract Amendment" },
  { value: "other", label: "Other" },
];

export const getReasonCodeLabel = (value: string): string =>
  REASON_CODE_OPTIONS.find((opt) => opt.value === value)?.label ?? value;

export const SUPPORTED_FILE_TYPES = ["application/pdf", "image/jpeg", "image/png"];
